import {createRef, FC, useCallback, useRef, useState} from "react";
// @ts-ignore
import MeasureTool from 'measuretool-googlemaps-v3';
import {API_URL, getRandomHighlightColor, sqMtrsToSqFt} from "../utils";

const containerStyle = {
    width: '100%',
    height: '400px'
};

const init_center = {
    lat: -3.745,
    lng: -38.523
};


const GoogleMapsAreaSelector: FC = () => {

    const mapElementRef = createRef<HTMLDivElement>()
    const mapRef = useRef<google.maps.Map>()
    const shapesRef = useRef<any>({})
    const drawingManagerRef = useRef<any>()
    const [storedPaths, setStoredPaths] = useState<any>({})


    const recreatePolygonsFromStoredData = (polygons: any, map: google.maps.Map) => {


        Object.keys(polygons).map(id => {
            if (polygons.hasOwnProperty(id)) {
                var pathData = polygons[id].paths;
                // Create an array to store the LatLng objects
                var path = [];

                // Populate the path array with LatLng objects from the stored data
                for (var i = 0; i < pathData.length; i++) {
                    var latLng = new google.maps.LatLng(pathData[i].lat, pathData[i].lng);
                    path.push(latLng);
                }

                // Create a new polygon using the path array
                shapesRef.current[id] = new google.maps.Polygon({
                    paths: path,
                    fillColor: polygons[id].color,
                    editable: true, // Allow the user to edit the polygon
                    map: map // Add the polygon to the map
                });

            }
        })
    }


    const initMap = useCallback((paths: any) => {
        if ( mapElementRef?.current && !mapRef.current) {

            const options: google.maps.MapOptions = {
                // @ts-ignore
                center: Object.values(paths)[0].paths[0],
                zoom: 20,
                mapTypeId: 'satellite',
                tilt: 0,
                rotateControl: false,
                streetViewControl: false,
                mapTypeControl: false,
            }

            mapRef.current = new google.maps.Map(mapElementRef.current, options);


            drawingManagerRef.current = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.POLYGON,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: [google.maps.drawing.OverlayType.POLYGON]
                },
                polygonOptions: {
                    editable: true
                }
            });
            drawingManagerRef.current.setMap(mapRef.current);


            if (mapRef.current) {

                recreatePolygonsFromStoredData(paths, mapRef.current)
                setTimeout(() => {
                    const totalArea = Object.keys(paths).reduce((acc, key) => {
                        // @ts-ignore
                        return acc + google.maps.geometry.spherical.computeArea(paths[key].paths)
                    }, 0)
                    setStoredPaths(paths)
                }, 2000)

            }


            google.maps.event.addListener(drawingManagerRef.current, "overlaycomplete", function (event: any) {
                if (event.type == google.maps.drawing.OverlayType.POLYGON) {
                    var polygon: google.maps.Polygon = event.overlay;
                    const color = getRandomHighlightColor()
                    polygon.setOptions({
                        fillColor: color
                    })
                    // Generate a unique identifier for the polygon
                    var id = 'polygon_' + Math.random().toString(36).substr(2, 9);
                    shapesRef.current[id] = polygon;

                    setStoredPaths((storedPaths: any) => {
                        return {
                            ...storedPaths,
                            [id]: {
                                color: color,
                                paths: polygon.getPath().getArray().map(function (coord: {
                                    lat: () => any;
                                    lng: () => any;
                                }) {
                                    return {lat: coord.lat(), lng: coord.lng()};
                                })
                            }
                        }

                    })


                    // Attach event listeners for polygon changes
                    google.maps.event.addListener(polygon.getPath(), 'set_at', function () {
                        setStoredPaths((storedPaths: any) => {
                            return {
                                ...storedPaths,
                                [id]: {
                                    color: color,
                                    paths: polygon.getPath().getArray().map(function (coord: {
                                        lat: () => any;
                                        lng: () => any;
                                    }) {
                                        return {lat: coord.lat(), lng: coord.lng()};
                                    })
                                }
                            }

                        })
                    });

                    google.maps.event.addListener(polygon.getPath(), 'insert_at', function () {

                        setStoredPaths((storedPaths: any) => {
                            return {
                                ...storedPaths,
                                [id]: {
                                    color: color,
                                    paths: polygon.getPath().getArray().map(function (coord: {
                                        lat: () => any;
                                        lng: () => any;
                                    }) {
                                        return {lat: coord.lat(), lng: coord.lng()};
                                    })
                                }
                            }

                        })
                    });

                    google.maps.event.addListener(polygon.getPath(), 'remove_at', function () {

                        setStoredPaths((storedPaths: any) => {
                            return {
                                ...storedPaths,
                                [id]: {
                                    color: color,
                                    paths: polygon.getPath().getArray().map(function (coord: {
                                        lat: () => any;
                                        lng: () => any;
                                    }) {
                                        return {lat: coord.lat(), lng: coord.lng()};
                                    })
                                }
                            }

                        })
                    });
                }
            });


        }

    }, [mapElementRef?.current])


    const getInvoice = async (invoice_no: string) => {
        const options: any = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({
                invoice_no
            })
        };

        await fetch(API_URL + '/getInvoice', options)
            .then(response => response.json())
            .then(response => {
                if (typeof response == 'object') {
                    initMap(response)
                } else if (typeof response == 'string') {
                    alert(response)
                } else {
                    alert(JSON.stringify(response))
                }
                return response
            })
            .catch(err => console.error(err));
    }

    return (
        <div className={"uk-section uk-section-small"}>
            <div className="uk-container">
                <input className={"uk-input"} placeholder={"Invoice Number"} onChange={(ev) => {
                    getInvoice(ev.currentTarget.value)
                }}/>

                <hr/>

                <div className="uk-grid uk-child-width-expand@m uk-grid-small" data-uk-grid>
                    <div>
                        <div style={containerStyle} ref={mapElementRef}>

                        </div>

                    </div>
                    <div className={"uk-width-1-4@m"}>
                        <div className="uk-card uk-card-default uk-card-body uk-card-small">
                            <ul className={"uk-list"}>
                                {Object.keys(storedPaths).map((key) => {
                                    return (
                                        <li className={"uk-flex uk-flex-middle"}>

                                            <span className={"uk-label uk-margin-small-right"} style={{
                                                background: storedPaths[key].color,
                                                width: '20px',
                                                height: 20
                                            }}></span>

                                            {sqMtrsToSqFt(google.maps.geometry.spherical.computeArea(storedPaths[key].paths))} sq.
                                            ft.

                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>

                </div>

            </div>
        </div>)

}

export default GoogleMapsAreaSelector